module.exports = __webpack_public_path__ + "static/media/grid-image.41498aa1.svg";